import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class ZipperTop extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {number} x 
     * @param {number} y 
     */
    constructor(scene, x, y)
    {
        super(scene, x, y);

        this.zipperContainer = this.scene.add.container();
        this.zipperBackground = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._game_assets_ZipperBg, this.zipperContainer).setOrigin(0);
        this.zipperOpen = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._game_assets_ZipperOpen, this.zipperContainer).setOrigin(0);
        this.zipperClosed = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._game_assets_ZipperClosed, this.zipperContainer).setOrigin(0);
        this.zipperClosed.x = this.zipperOpen.width - 5;
        this.zipperClosed.y = (this.zipperBackground.height / 2) - (this.zipperClosed.height / 2) - 3;

        this.zipperContainer.x = -this.zipperOpen.width;

        this.zipperPull = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._game_assets_ZipperPull, this.zipperContainer).setOrigin(0);
        this.zipperPull.x = this.zipperClosed.x;
        this.zipperPull.y = this.zipperClosed.y;
        this.add(this.zipperContainer);
        this.zipperContainer.x = this.scene.scale.width;
        this.isOpen = true;
    }

    toggle()
    {
        this.isOpen = !this.isOpen;
        if (this.isOpen)
        {
            this.close();
        } 
        else
        {
            this.open();
        }
    }

    open()
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._Zipper_Open, this.scene);
        this.scene.tweens.killTweensOf(this.zipperContainer);
        ABCyaPhaser.Tweens.addTween(this.zipperContainer, 440, {x:this.scene.scale.width}, Phaser.Math.Easing.Quadratic.Out);
    }

    close()
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._Zipper_Close, this.scene);
        ABCyaPhaser.Tweens.addTween(this.zipperContainer, 440, {x:-this.zipperOpen.width}, Phaser.Math.Easing.Quadratic.Out);
    }

    changeColor(value)
    {
        this.zipperBackground.setTint(value);
    }
}